(function () {
  function setup(gallery) {
    const track = gallery.querySelector('.product__media-list');
    const slides = track ? Array.from(track.querySelectorAll('.product__media-item')) : [];

    if (!track || slides.length <= 1 || gallery.dataset.dotsInitialized) return;
    gallery.dataset.dotsInitialized = 'true';

    const dots = document.createElement('div');
    dots.className = 'gallery-dots';
    dots.setAttribute('role', 'tablist');

    slides.forEach((slide, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'gallery-dots__dot';
      dot.setAttribute('aria-label', `Show image ${index + 1}`);
      if (index === 0) dot.classList.add('is-active');
      dot.addEventListener('click', () => {
        slide.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      });
      dots.appendChild(dot);
    });

    gallery.insertAdjacentElement('afterend', dots);

    const dotEls = Array.from(dots.children);
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = slides.indexOf(entry.target);
            if (index === -1) return;
            dotEls.forEach((dot) => dot.classList.remove('is-active'));
            dotEls[index].classList.add('is-active');
          }
        });
      },
      { root: track, threshold: 0.6 }
    );

    slides.forEach((slide) => observer.observe(slide));
  }

  function init() {
    document.querySelectorAll('.product__media-wrapper').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
